export default "__VITE_ASSET__6cf1c899__"